import { actions } from '../constants/friendbuy_light_box/actions';
import Dispatcher from '../dispatcher';

export const show = () =>
    Dispatcher.handleFriendbuyLightBoxAction({ type: actions.SHOW });

export const hide = () =>
    Dispatcher.handleFriendbuyLightBoxAction({ type: actions.HIDE });
